import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import backButton from '../../../../components/backButton/backButton.vue'
import titleLine from '../../../../components/titleLine/titleLine'
import * as requestApi from '@/utils/appointment.url' 
import * as requiredUrls from '../../../../utils/appointment.url'
import { getCookie } from "@/utils/utils.js"; // 引入接口
import serviceRule from './serviceRule.vue';
import { getDataSetSensitive } from '@/utils/sensitiveUtil.js'
export default {
  name: 'basicInfo',
  components: {
    BreadCrumb,
    steps,
    backButton,
    titleLine,
    serviceRule
  },
  watch: {
    checked(value){
      if(value){
        this.disabled = false;
      }else{
        this.disabled = true;
      }
      
    }
  },
  data() {
    return {
      stepsType: this.$route.query.stepsType,  
      extentedType:this.$route.query.extentedType,
      checked:false, 
      disabled:true,
      dialogVisible:false,
      options:[
      {
        value:10,
        label:'身份证'
      },
      {
        value:11,
        label:'军官证'
      },
      {
        value:12,
        label:'士兵证'
      },
      {
        value:13,
        label:'警官证'
      },
      {
        value:14,
        label:'港澳居民来往内地通行证'
      },
      {
        value:15,
        label:'台湾居民来往大陆通行证'
      },
      {
        value:16,
        label:'香港身份证'
      },
      {
        value:17,
        label:'澳门身份证'
      },
      {
        value:18,
        label:'台湾身份证'
      },
      {
        value:19,
        label:'退伍证'
      },
      {
        value:20,
        label:'护照'
      },
      {
        value:21,
        label:'驾照'
      },{
        value:90,
        label:'其他'
      }
    ], 
      businessInfo:{
        bsName:this.$route.query.bsName || '-',//预约业务
        matterName: this.$route.query.matterName,// 预约事项 
        hallName:this.$route.query.hallName || '-',//服务大厅
        date:this.$route.query.appointmentInfo ? this.$route.query.appointmentInfo.date : '',//预约日期 
        beginTime:this.$route.query.appointmentInfo ? this.$route.query.appointmentInfo.beginTime : '',
        endTime:this.$route.query.appointmentInfo ? this.$route.query.appointmentInfo.endTime :'',
        remainNum: this.$route.query.remainNum, //剩余预约号数量
        handleNum: 1, // 办理数量
        batOpenStatus: this.$route.query.batOpenStatus, // 批量预约服务开关
        ifMulPlaces: this.$route.query.ifMulPlaces, // 批量件是否占用多个预约名额
        maxOfHandle: this.$route.query.maxOfHandle, // 批量件最大办理数量
      },
      infoForm: { 
        name: '', // 预约姓名
        phone: '', // 预约手机
        paperType:'',//证件类型
        idCard: '', // 证件号码 
        comName: '', // 企业名称
        creditCode:'',//统一社会信用码 
        utype:'',//用户登录类型，个人、法人
      },
      infoFormRules: {
        name: {
          required: true,
        },
        idCard: {
          required: true,
        },
        phone: {
          required: true,
        },
        comName: {
          required: true,
        },
        creditCode: {
          required: true,
        } 
      },
    }
  },
  methods: { 
    // 查看预约规则
    serviceRule(){ 
      this.dialogVisible = true;
    },
    subMit() {
      this.disabled = true;
      if(this.checked){
        requestApi.submitAppointment({
          bsSeq:this.$route.query.bsSeq,
          date:this.$route.query.appointmentInfo.date,
          timeToken:this.$route.query.appointmentInfo.timeToken,
          timeSeq:this.$route.query.appointmentInfo.timeSeq,
          itemSeq:this.$route.query.matterSeq,
          reserveSrc: 0, // 预约渠道 0、PC端自主预约；
          handleNum: this.businessInfo.batOpenStatus == 1 ? this.businessInfo.handleNum : '',
          // 提交接口配置了白名单了，预约流程提交需要传userCode了
          userCode: sessionStorage.getItem("userCode"),
          operaterName: this.infoForm.comName
        },'post').then(res => {
          if(Number(res.status) === 200){
            this.$route.query.appointmentInfo.success = res.data.success;//预约结果
            this.$route.query.appointmentInfo.aiShow = res.data.aiShow;//是否显示补充信息框
            this.$route.query.appointmentInfo.code = res.data.code; //预约流水号
            this.$route.query.appointmentInfo.seq = res.data.seq;//预约主键
            console.log('预约信息--',this.$route.query.appointmentInfo);
            this.$router.push({
              path: '/complete',
              query: {
                ...this.$route.query,
                unitSeq: this.$route.query.unitSeq,
                hallSeq: this.$route.query.hallSeq,
                avgTime: res.data.avgTime
              }
            }) 
          }else{
            if(Number(res.status) === 400){
              // 启用提交按钮以便重新输入办理数量
              this.disabled = false;
            }
            this.$message.error(res.desc);
          }
        })
      }else{
        this.$message.error('请阅读并同意预约服务规则');
      } 
    },
    //获取用户信息回显
    getUserInfo() {
      requiredUrls.interOutUserInfo( {
        //0、获取用户信息接口
        loginaware: true // 正式环境使用loginaware
      }, "get" ).then(resUserInfo => { 
        let utype = resUserInfo.data.userInfo.uType;//登录类型 1：个人用户登录 2：法人登录
        this.infoForm.name = utype == 1 ? resUserInfo.data.userInfo.name : resUserInfo.data.userInfo.handlerName; 
        this.infoForm.phone =  resUserInfo.data.userInfo.mobilePhone || '' ; //手机号码
        this.infoForm.paperType =  utype == 1 ? Number(resUserInfo.data.userInfo.paperType) : Number(resUserInfo.data.userInfo.handlerIdType);//证件类型
        this.infoForm.idCard =  utype == 1 ? resUserInfo.data.userInfo.paperCode : resUserInfo.data.userInfo.handlerId;//证件号 
        this.infoForm.comName =  utype != 1 ?resUserInfo.data.userInfo.name : '';
        this.infoForm.creditCode = utype != 1 ?resUserInfo.data.userInfo.credNum : '';
        this.infoForm.utype = resUserInfo.data.userInfo.uType;
        if(resUserInfo.data.childUserInfo){
          let utype = resUserInfo.data.childUserInfo.uType;
          this.infoForm.name = utype == 1 ? resUserInfo.data.childUserInfo.name : resUserInfo.data.childUserInfo.handlerName;
          this.infoForm.phone =  resUserInfo.data.childUserInfo.mobilePhone || '' ; //手机号码 
          this.infoForm.paperType =  utype == 1 ? Number(resUserInfo.data.childUserInfo.paperType) : Number(resUserInfo.data.childUserInfo.handlerIdType);//证件类型
          this.infoForm.idCard =  utype == 1 ? resUserInfo.data.childUserInfo.paperCode : resUserInfo.data.childUserInfo.handlerId;//证件号 
        }
        this.$nextTick(() => {
          getDataSetSensitive('desensitization');
        });
      });
    }
  },
  mounted() { 
    console.log(this.$route.query)
    if (getCookie("access-token")) {
      this.getUserInfo()
    }
    document.querySelector('[role="checkbox"]').addEventListener('keydown', et => {
      if(et.keyCode == 13){
        this.checked = !this.checked;
      }
    })
  }
}
